import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { API } from "@service/system/api.service";
import { HttpManager } from "@service/system/httpManager.service";

const API_URL = API.API_URL;

@Injectable()
export class StatesService {
  private _statesURL = API_URL + "/states";

  constructor(private httpManager: HttpManager) { }

  getStates(): Observable<any> {
    return this.httpManager.httpGet<any>(this._statesURL);
  }
}
